import { createRef } from "react";

export const toastRef = createRef();

export const toast = {
  success: (msg) => toastRef.current?.showToast("success", msg),
  error: (msg) => toastRef.current?.showToast("error", msg),
  info: (msg) => toastRef.current?.showToast("info", msg),
};
